// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinnerLogo":"LoadingSpinner_loadingSpinnerLogo__3zxmX","welcomeToSynapse":"LoadingSpinner_welcomeToSynapse__2cwjJ"};